<template>
  <div id="test-question">
    <div class="backdrop">
      <div class="img-container">
        <img src="../../assets/bg-test.png" :style=setPos alt="">
      </div>
    </div>
    <comp-header
      :headerPosition="headerPos"
      :leftIcon="headerLeftIcon"
      :leftClick="check"
      :rightLink="headerRightLink"
      :pageTitle="headerPageTitle"
      :rightClick="tmpSave"
    ></comp-header>
    <div class="tq-wrapper">
      <div class="tq-container">
        <p class="current-num">{{ questionNum }} / {{ maximum }}</p>
        <p class="current-txt">{{ questionContent }}</p>
      </div>
    </div>
    <div class="absolute-bottom">
      <form-button
        :btnName="$t('test.question.stronglyAgree')"
        @parentCall="submission(stronglyAgree)"
      />
      <form-button
        :btnName="$t('test.question.agree')"
        @parentCall="submission(agree)"
      />
      <form-button
        :btnName="$t('test.question.disagree')"
        @parentCall="submission(disagree)"
      />
      <form-button
        :btnName="$t('test.question.stronglyDisagree')"
        @parentCall="submission(stronglyDisagree)"
      />
    </div>
    <comp-modal
      v-if="showModal"
      @confirm="showModal = false"
    >
      <div slot="body">{{ msgModal }}</div>
    </comp-modal>
    <comp-loading
      v-if="isLoading"
    ></comp-loading>
  </div>
</template>

<script>
import common from '@/utils/common';
import CompModal from '@/components/CompModal';
import CompLoading from '@/components/CompLoading';
import CompHeader from '@/components/CompHeader';
import FormButton from '@/components/FormButton';
import RESPONSE from '@/constants/response';
import TEST from '@/constants/test';

export default {
  name: 'test-question',
  mixins: [
    common,
  ],
  data() {
    return {

      headerPos: 'on-top',
      headerLeftIcon: 'fa-chevron-left',
      headerRightLink: this.$i18n.t('test.question.headerRight'),
      headerPageTitle: this.$i18n.t('test.question.header'),

      id: '',
      eId: '',
      num: '',
      question: '',
      realNum: '',

      titleModal: '',
      msgModal: '',
      showModal: false,

      isLoading: false,

      stronglyAgree: TEST.ITEM.STRONGLY_AGREE,
      agree: TEST.ITEM.AGREE,
      disagree: TEST.ITEM.DISAGREE,
      stronglyDisagree: TEST.ITEM.STRONGLY_DISAGREE,
      maximum: TEST.MAXIMUM,

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,
    };
  },
  components: {
    CompHeader,
    FormButton,
    CompModal,
    CompLoading,
  },
  computed: {
    questionNum() {
      return this.num;
    },
    questionContent() {
      return this.question;
    },
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
  methods: {
    getQuestion() {
      this.isLoading = true;

      this.$store.dispatch('getQuestion')
        .then((result) => {
          if (result.status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.getQuestion();
              } else {
                this.invalidateLogin();
              }
            });
          } else if (result.status === RESPONSE.SUCCESS.CODE) {
            this.setQuestion(result.data.data);
          } else {
            if (result.error.resultCode === RESPONSE.NO_QUESTION.CODE) {
              const qCnt = TEST.MAXIMUM;
              this.$store.dispatch('setQCnt', { qCnt }).then();
              this.goPage('/test/done');
            }
            this.msgModal = result.error.resultMsg;
            this.showModal = true;

            this.isLoading = false;
          }
        });
    },
    setQuestion(question) {
      this.isLoading = false;

      const qCnt = question.qCnt;
      this.$store.dispatch('setQCnt', { qCnt }).then();
      this.id = question.idx;
      this.eId = question.eId;
      this.num = qCnt;
      this.question = question.qMent;
      this.realNum = question.number;
      const buttons = this.$el.querySelectorAll('.Button');
      buttons.forEach((e) => {
        e.disabled = false;
        e.classList.remove('process');
      });
    },
    submission(value) {
      this.isLoading = true;

      const buttons = this.$el.querySelectorAll('.Button');
      buttons.forEach((e, index) => {
        if (index === (value - 1)) {
          e.classList.add('process');
        }
        e.disabled = true;
      });
      const data = {
        QMID: this.id,
        engineId: this.eId,
        AnswerNum: value,
        QCNT: this.num - 1,
        QuestionNum: this.realNum,
        lang: this.$store.getters.getLanguage,
      };
      this.$store.dispatch('postQuestion', { data })
        .then(() => this.getQuestion());
    },
    check() {
      // if (this.num > TEST.MINIMUM) {
      //   return this.goPrevious();
      // }
      // this.msgModal = this.$i18n.t('test.question.minimum');
      // this.showModal = true;
      // return null;
      return this.goPrevious();
    },
    tmpSave() {
      // if (this.num > TEST.MINIMUM) {
      //   return this.goPage('/mc6');
      // }
      // this.msgModal = this.$i18n.t('test.question.minimum');
      // this.showModal = true;
      // return null;
      return this.goPage('/mc6');
    },
    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
  },
  created() {
    this.getQuestion();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss" src="../../scss/test-question.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/test/test-question.vue